import { Component, HostListener } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormValidation } from '../../shared/services/utils/form-validation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { SettingsService } from '../../shared/services/settings.service';
import { MenuService } from '../../shared/services/menuconfig.service';
import { ContactUsDto } from '../../models/contact-us.model';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { CarouselLandingComponent } from './carousel-landing/carousel-landing.component';
import { HomeTitleComponent } from './home-title/home-title.component';
import { HomeCategoriesComponent } from './home-categories/home-categories.component';
import { HomeBestCoursesComponent } from './home-best-courses/home-best-courses.component';
import { ProductComponent } from './product/product.component';
import { SharedModule } from '../../shared/shared.module';
import { showNotification } from '../../consts/utils';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PackageComparisonComponent } from './package-comparison/package-comparison.component';
import { TranslateModule } from '@ngx-translate/core';
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-home-page',
  imports: [SharedModule, ReactiveFormsModule, HeaderComponent, CarouselLandingComponent, HomeTitleComponent, HomeCategoriesComponent, HomeBestCoursesComponent, ProductComponent, PackageComparisonComponent, TranslateModule],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})

export class HomePageComponent {

  form: UntypedFormGroup;
  validate: boolean = false;
  disabledButton: boolean = false;

  constructor(private _formBuilder: UntypedFormBuilder,
    public formValidation: FormValidation,
    private _settingsService: SettingsService,
    private snackBar: MatSnackBar,
    public menuService: MenuService,
    private seo: SeoService,
    public layout: LayoutService) {
    /**
  * Sets up SEO meta tags using SeoService
  * This helps in optimizing the page for search engines and social media previews.
*/
    this.seo.setTags({
      title: 'Main Home page', // Title
      titleSuffix: '- Shining On Safety', // Title Suffix
      description: 'Shining On Safety', // Description
      image: '', // Image
      keywords: 'Shining On Safety' // Keywords
    });
  }


  ngOnInit(): void {
    this.form = this._formBuilder.group({
      name: ['',
        [
          Validators.compose([
            Validators.required,
            Validators.maxLength(80),
            Validators.minLength(4)
          ])
        ],
      ],
      email: ['',
        [
          Validators.compose([
            Validators.required,
            Validators.email,
            Validators.maxLength(100),
            Validators.minLength(4)
          ])
        ],
      ],
      comment: ['',
        [
          Validators.compose([
            Validators.required,
            Validators.maxLength(200),
            Validators.minLength(4)
          ])
        ],
      ],
    });
  }

  scrollToAboutUs() {
    const element = document.getElementById('about-us');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  public innerWidth: number;
  public footerFix = false;
  public footerLight = false;
  public footerDark: boolean = false;
  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    if (window.innerWidth < 1200) {
      this.layout.config.settings.sidebar_type = "page-wrapper compact-wrapper";
    }
  }

  get layoutClass() {
    return (
      this.layout.config.settings.sidebar_type + ''
    );
  }

  ngDoCheck() {
    if (window.location.pathname == "/page-layout/footer-dark") {
      this.footerDark = true;
      this.footerLight = false;
      this.footerFix = false;
    } else if (window.location.pathname == '/page-layout/footer-light') {
      this.footerLight = true;
      this.footerDark = false;
      this.footerFix = false;
    } else if (window.location.pathname == '/page-layout/footer-fixed') {
      this.footerFix = true;
      this.footerLight = false;
      this.footerDark = false;
    }
  }

  ngOnDestroy() {
    this.footerDark = false;
  }

  sendEmail() {
    this.validate = true;
    this.disabledButton = true;
    if (!this.form.valid) {
      showNotification(this.snackBar, 'Please check the form fields', 'error');
      this.disabledButton = false;
      return;
    }
    const contactUsDto: ContactUsDto = {
      name: this.form.get("name")?.value,
      email: this.form.get("email")?.value,
      comments: this.form.get("comment")?.value
    }
    this._settingsService.sendContactUs(contactUsDto).subscribe({
      next: (res: any) => {
        showNotification(this.snackBar, res.message, 'success');

        this.form.get("name")?.setValue("");
        this.form.get("email")?.setValue("");
        this.form.get("comment")?.setValue("");
        this.disabledButton = false;
        this.validate = false;
      },
      error: (error) => {
        showNotification(this.snackBar, error.message, 'success');
      },
    });
  }

  scrollToContactUs() {
    const el = document.getElementById('contact-us');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

}
